module.exports = __webpack_public_path__ + "img/interpack-active.c2c91ec0.svg";